import Vue from 'vue'
import Vuex from 'vuex'

import { dev, prod } from "./environtments"
let targetEnv = dev
if (process.env.NODE_ENV == 'production') {
  targetEnv = prod
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api: targetEnv.api,
    apiNerdof: targetEnv.apiNerdof,
    serverName: targetEnv.serverName,
    secretKey: targetEnv.secretKey,
    frontend: targetEnv.frontend
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
